<template>
  <div class="box-admin new-client-wrapper col-md-4">
    <blocHeaderTitle
      :titre="titre"
      :sous-titre="clientName"
      :icone="['fas', 'user-tie']"
    ></blocHeaderTitle>
    <b-form @submit.prevent="onSubmit">
      <b-form-group id="prenom-group" label="Prénom" label-for="prenom-input">
        <b-form-input
          v-model="users.prenom"
          id="prenom-input"
          type="text"
          required
        >
        </b-form-input>
      </b-form-group>

      <b-form-group id="nom-group" label="Nom" label-for="nom-input">
        <b-form-input v-model="users.nom" id="nom-input" type="text" required>
        </b-form-input>
      </b-form-group>

      <b-form-group
        id="email-group"
        label="Adresse e-mail"
        label-for="email-input"
      >
        <b-form-input
          v-model="users.email"
          id="email-input"
          type="email"
          required
        >
        </b-form-input>
      </b-form-group>

      <b-form-group
        id="acces-group"
        label="Droits d'accès"
        label-for="acces-input"
      >
        <b-form-select
          id="acces-input"
          type="text"
          required
          v-model="selected"
          :options="options"
          @change="handleChange"
        >
        </b-form-select>
      </b-form-group>
      <b-form-checkbox
        v-if="isEditMode"
        v-model="activated"
        name="check-button"
        switch
        @change="handleActivationLicense"
      >
        Activer/desactiver licence
      </b-form-checkbox>
      <div class="button-wrap d-flex justify-content-end">
        <b-button variant="outline-primary">Annuler</b-button>
        <b-button type="submit" variant="primary" class="lg-btn">{{
          titreButton
        }}</b-button>
      </div>
    </b-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import blocHeaderTitle from '../../components/utils/blocHeaderTitle'
export default {
  components: {
    blocHeaderTitle
  },
  data () {
    return {
      selected: 'ROLE_ADMIN',
      options: [
        { value: 'ROLE_ADMIN', text: 'Administrateur' },
        { value: 'ROLE_UTILISATEUR', text: 'Utilisateur' }
      ],
      users: {
        nom: '',
        prenom: '',
        email: '',
        roles: 'ROLE_ADMIN',
        societe: parseInt(this.$route.params.idclient)
      },
      etatLicense: 0,
      clientName: '',
      titre: this.$route.params.iduser ? 'Modifier utilisateur' : 'Nouvel utilisateur',
      titreButton: this.$route.params.iduser ? 'Modifier' : 'Ajouter',
      activated: false,
      isEditMode: !!this.$route.params.iduser
    }
  },
  mounted () {
    this.getClientName(parseInt(this.$route.params.idclient, 10))

    if (this.$route.params.iduser) {
      this.getUser(this.$route.params.iduser).then((resp) => {
        this.users = resp
        this.selected = resp.roles

        if (resp.licence.length > 0) {
          if (resp.licence[0].etat === 2) {
            this.etatLicense = 2
            this.activated = true
            return
          }

          this.etatLicense = 3
          this.activated = false
        }
      })
    }
  },
  methods: {
    ...mapActions(['createUser', 'getClients', 'getUser', 'updateUser', 'activeLicence', 'deactiveLicence']),
    onSubmit () {
      // update user
      if (this.$route.params.iduser) {
        this.updateUserInfo()
        return
      }
      // create user
      this.createUserInfo()
    },
    handleChange (e) {
      this.users.roles = e
    },
    getClientName (id) {
      this.getClients().then((resp) => {
        this.clientName = resp.items.filter(x => x.id === id)[0].nom
      })
    },
    updateUserInfo () {
      const user = Object.assign({}, this.users)
      delete user.licence
      user.etatLicense = this.etatLicense
      this.updateUser({ users: user, id: this.$route.params.iduser }).then((resp) => {
        this.$toaster.success('Modifié')
        this.$router.push({ path: `../../list-user/${this.$route.params.idclient}` })
      }, (err) => {
        this.$toaster.error(err)
      })
    },
    createUserInfo () {
      this.createUser(this.users).then((resp) => {
        this.$toaster.success('Utilisateur ajouté avec succès')
        this.$router.push({ path: `../list-user/${this.$route.params.idclient}` })
      }, (err) => {
        this.$toaster.error(err)
      })
    },
    handleActivationLicense (e) {
      this.activated = e
      if (e) {
        this.etatLicense = 2
        return
      }
      this.etatLicense = 3
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ajoutUserByEditeur/index.vue